import MobileShopV2Impl from "./MobileShopV2Chunk";

export default function MobileShopV2(props) {
  return <MobileShopV2Impl {...props} />;
}
